
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgxHekaDesignLibModule } from 'ngx-heka-design-lib';

@Component({
  selector: 'app-multi-domain-invitation-error-dialog',
  imports: [NgxHekaDesignLibModule, MatButtonModule, MatDialogModule, TranslateModule],
  templateUrl: './multi-domain-invitation-error-dialog.component.html',
  standalone: true,
  styleUrl: './multi-domain-invitation-error-dialog.component.scss'
})
export class MultiDomainInvitationErrorDialogComponent {}
